import * as Sentry from '@sentry/react';
import { Severity } from '@sentry/react';

type Primitive = string | number | boolean | null | undefined;
type Data = Record<string, Primitive | Primitive[] | Record<string, Primitive>>;

const CATEGORY = 'auth-flow';

export const authBreadcrumb = (message: string, data?: Data) => {
  Sentry.addBreadcrumb({
    category: CATEGORY,
    level: Severity.Info,
    message,
    data,
  });
};

export const captureAuthError = (error: unknown, step: string, extras?: Data) => {
  Sentry.withScope(scope => {
    scope.setTag('auth.flow', step);
    scope.setLevel(Severity.Error);
    scope.setContext('authFlow', {
      step,
      url: typeof window !== 'undefined' ? window.location.href : null,
      timestamp: new Date().toISOString(),
      ...extras,
    });
    const err = error instanceof Error ? error : new Error(`[${step}] ${String(error)}`);
    Sentry.captureException(err);
  });
};

export const setAuthUserContext = (info: { uid?: string | null; email?: string | null; hasFirestoreDoc?: boolean }) => {
  Sentry.setUser({
    id: info.uid ?? undefined,
    email: info.email ?? undefined,
  });
  Sentry.setTag('auth.uid', info.uid ?? 'anonymous');
  if (typeof info.hasFirestoreDoc === 'boolean') {
    Sentry.setTag('auth.hasFirestoreDoc', String(info.hasFirestoreDoc));
  }
};
